import React from 'react';
import { Form } from 'antd';
import PropTypes from 'prop-types';
import { CustomInput } from '../../../../atoms';
import {
  VALUE_TYPE_MONEY,
  VALUE_TYPE_PERCENTAGE,
} from '../../../../../services/repository/settingRepository/objects/setting';

function DefaultValueInput({ id, label, valueType, onChange, value }) {
  const handleOnChangeValue = (changedValue) =>
    onChange(id, valueType, changedValue);
  return (
    <Form.Item label={label}>
      {valueType === VALUE_TYPE_PERCENTAGE && (
        <CustomInput suffix="%" value={value} getValue={handleOnChangeValue} />
      )}
      {valueType === VALUE_TYPE_MONEY && (
        <CustomInput prefix="R$" value={value} getValue={handleOnChangeValue} />
      )}
    </Form.Item>
  );
}

DefaultValueInput.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  valueType: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired,
};

export default DefaultValueInput;
